import Text from 'components/ui/Text';
import { useTranslation } from 'react-i18next';

type OrderLineNumberCellProps = {
    orderLineNumber?: string | null;
};

const OrderLineNumberCell = ({ orderLineNumber }: OrderLineNumberCellProps) => {
    const { t } = useTranslation();

    return (
        <Text as="span" fontSize={12}>
            {orderLineNumber ?? t('notAvailable', 'N/A')}
        </Text>
    );
};

export default OrderLineNumberCell;
